export const ToastMessages = {
  formDeletedSuccess: 'Form deleted successfully',
  formDeleteFailed: 'Failed to delete form',
  formArchivedSuccess: 'Form archived successfully',
  formArchiveFailed: 'Failed to archive form',
  formUnarchivedSuccess: 'Form unarchived successfully',
  formUnarchiveFailed: 'Failed to unarchive form',
  formRetrievedSuccess: 'Form retrieved successfully',
  formRetrieveFailed: 'Failed to retrieve forms',
  templateDeletedSuccess: 'Template deleted successfully',
  templateDeleteFailed: 'Failed to delete template',
  templateArchivedSuccess: 'Template archived successfully',
  templateArchiveFailed: 'Failed to archive template',
  templateUnarchivedSuccess: 'Template unarchived successfully',
  templateUnarchiveFailed: 'Failed to unarchive template',
  templateRestoredSuccess: 'Template restored successfully',
  templateRestoreFailed: 'Failed to restore template',
  templateRetrievedSuccess: 'Templates retrieved successfully',
  templateRetrieveFailed: 'Failed to retrieve templates',
  errorGeneral: 'An error occurred. Please try again.', // Added
  invalidDataFormat: 'Invalid data format received.', // Added
  emailSentSuccess: 'Email sent successfully', // Added
  emailSendFailed: 'Failed to send email', // Added
  formNotFound: 'Form not found' // Added
};

export const TextMessages = {
  trashWarning: 'The forms in the trash will be deleted within 30 days from the date of deletion',
  chooseOption: 'Choose an Option',
  startFromScratch: 'Start From Scratch',
  templates: 'Templates',
  formLink: 'Form Link',
  sendViaEmail: 'Send Via Email',
  chooseAnTemplate: 'Select a template to start building your form',
  parsedTemplates: 'Parsed Templates'
};